import InstructorCourses from "../components/instructor/InstructorCourses";
import InstructorNavbar from "../components/instructor/InstructorNavbar";
// import Navbar from "../components/layout/Navbar";


const InstructorCoursesPage = () => {
    return ( 
        <>
        <InstructorNavbar/>
        <InstructorCourses/>
        </>
     );
}
 
export default InstructorCoursesPage;